import { format, parseISO } from 'date-fns'

export interface TodoItem {
  due_date: string
  is_overdue: boolean
}

/** "Overdue · 12 Sep" for a past-due row, "Due 18 Sep" otherwise. */
export function dueLabel(item: TodoItem): string {
  const formatted = format(parseISO(item.due_date), 'd MMM')
  return item.is_overdue ? `Overdue · ${formatted}` : `Due ${formatted}`
}

/** Footer/badge count beyond what the card shows, including zero when nothing is truncated. */
export function moreCount(total: number, shownCount: number): number {
  return Math.max(0, total - shownCount)
}
